import { BaseGroupType } from "src/app/reusables/models/group-type.model";

export enum MarketplaceOrderStatus {
    Created = 0,
    Processing = 1,
    InTransit = 2,
    ReadyForPickup = 3,
    Complete = 4,
    Cancelled = 5,
    Shipped = 6
}

export interface MarketplaceProductOrdered {
    Category: string;
    CompanyID: number;
    Description: string;
    PointStoreOrderID: number;
    PointStoreProductID: number;
    ProductCost: number;
    ProductImageID: number;
    ProductOrderedID: number;
    ProductQuantity: number;
    ProductStatus: MarketplaceOrderStatus;
    SubCategory: string;
    Title: string;
}

export interface MarketplaceOrder {
    CompanyID: number;
    DateOrdered: string;
    LoginID: number;
    LoginName: string;
    Note: string;
    OrderStatus: MarketplaceOrderStatus;
    OrderTotal: number;
    PointStoreOrderID: number;
    RelatedGroupID: number;
    RelatedGroupLevel: number;
    RelatedGroupType: BaseGroupType;
    ProductsCollection?: MarketplaceProductOrdered[];
}

export interface GroupHeader {
    ColumnName: string;
    HideColumn: boolean;
}